import styled, { css } from "styled-components";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import * as MonthlyPrice from "../../common/price/styles/MonthlyPrice";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { h5Style, bodyStyle } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Banner = styled.div`
    position: relative;
    width: 100%;
    height: 170px;
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;
`;

export const Image = styled(ImageFluid)`
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: auto;
    border-radius: 4px;
    transform: translateY(-50%);
`;

export const ServiceWrapper = styled.div<{ selected?: boolean }>`
    margin: ${theme.space[4]}px 0;
    padding: ${theme.space[3]}px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    &:first-child {
        margin-top: 0px;
    }

    ${({ selected }) =>
        selected &&
        css`
            border: 1.5px solid ${theme.colors.azure};
            box-shadow: none;
        `};
`;

export const Title = styled(Type.H1)`
    ${h5Style};
    color: ${theme.colors.steel};
`;

export const Description = styled.div`
    margin-top: ${theme.space[2]}px;
    padding-bottom: ${theme.space[2]}px;
    color: ${theme.colors.platinumDark};
    ${bodyStyle};
`;

export const List = styled(Flex.Row)`
    justify-content: space-between;
    margin: 10px 0;
    padding-bottom: 10px;
    color: ${theme.colors.platinumDark};
    border-bottom: 1px solid ${theme.colors.platinumLight};

    strong {
        font-family: ${theme.fonts.bold};
        font-weight: normal;
    }
`;

export const Row = styled(Flex.Row)`
    justify-content: space-between;
    margin: 20px 0;
`;

export const Col = styled(Flex.Col)`
    padding-left: 0;

    html[direction="rtl"] & {
        padding-left: ${theme.spacer / 2}px;
        padding-right: 0;
    }
`;

export const Panel = styled.div<{ isLoading?: boolean }>`
    position: relative;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.silver};
    border-radius: 4px;

    ${({ isLoading }) =>
        isLoading &&
        css`
            height: 85px;
            margin-bottom: ${theme.space[3]}px;
        `}
`;

export const PanelFooter = styled(Flex.Row)`
    justify-content: space-between;
    margin: ${theme.space[4]}px ${theme.space[4]}px 0 0;
    padding-top: ${theme.space[3]}px;

    ${MonthlyPrice.Text} {
        font-family: ${theme.fonts.bold};
        font-size: 1.7rem;
        color: ${theme.colors.midnight};
    }
`;

export const FooterRows = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const ActionDetails = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: ${theme.space[3]}px;
    @media ${getBreakpoint("up", "md")} {
        margin-top: 0;
    }
`;

export const Toggle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 15px 0;
    border-top: 1px solid ${theme.colors.platinumLight};
    border-bottom: 1px solid ${theme.colors.platinumLight};
`;

export const ToggleText = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const OutlineLink = styled(Button.Link)`
    display: inline-block;
    border: 1px solid ${theme.colors.platinumLight};
`;

export const TradeInWrapper = styled(ServiceWrapper)<{ topBorder?: boolean }>`
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    border-top: 1px solid ${({ topBorder }) => (topBorder ? theme.colors.platinumLight : "transparent")};
`;

export const RemoveButton = styled(Button.Link)`
    margin-left: ${theme.space[2]}px;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[2]}px;
    }
`;

export const ListWrapper = styled.div`
    margin-top: 30px;
    strong {
        color: ${theme.colors.platinumDark};
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    max-width: 100%;
`;

export const MonthlyPriceWrapper = styled.strong`
    margin-bottom: 20px;
`;

export const IntroductionWrapper = styled.div`
    margin: 50px 0;
    ${Type.H1} {
        font-size: 3.2rem;
    }
`;

export const IntroductionDescription = styled.div`
    margin: ${theme.space[2]}px 0;
    color: ${theme.colors.platinumDark};
`;

export const Table = styled.table`
    width: 100%;
    padding: ${theme.space[2]}px 0;
    td {
        font-size: 1.6rem;
        line-height: 2.4rem;
        &:first-child {
            width: 40%;
            font-family: ${theme.fonts.regular};
            color: ${theme.colors.black};
        }
        &:last-child {
            width: 60%;
            font-family: ${theme.fonts.book};
            color: ${theme.colors.black};
        }
    }
`;

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;
